/** Barrinhas de progresso dos fluxos mobile (C-11). `current` começa em 1. */
export default function StepBars({ total, current }: { total: number; current: number }) {
  return (
    <div className="steps" aria-label={`Passo ${current} de ${total}`}>
      {Array.from({ length: total }, (_, i) => <i key={i} className={i + 1 < current ? 'done' : i + 1 === current ? 'cur' : ''} />)}
    </div>
  );
}
